/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterDto } from '../../models/mitarbeiter-dto';

export interface SetMitarbeiterInactive$Json$Params {

/**
 * ID des Mitarbeiters der inaktiv gesetzt werden soll
 */
  mitarbeiterId: string;
}

export function setMitarbeiterInactive$Json(http: HttpClient, rootUrl: string, params: SetMitarbeiterInactive$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterDto>> {
  const rb = new RequestBuilder(rootUrl, setMitarbeiterInactive$Json.PATH, 'delete');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterDto>;
    })
  );
}

setMitarbeiterInactive$Json.PATH = '/v1/mitarbeiter/delete/{mitarbeiterId}';
